import { handleLoginFirebase, handleLogout } from "../../api/firebaseFunctions";

export const Types = {
    LOGIN: 'login/LOGIN',
    LOGOUT: 'login/LOGOUT',
    ERROR: 'login/ERROR',
}

const INITIAL_STATE = {
    data: null,
    loading: false,
    error: null,
};

export default function login(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.LOGIN:
            return {
                ...state,
                data: action.payload,
                loading: false,
                error: false,
            };
        case Types.LOGOUT:
            return {
                ...state,
                data: action.payload,
                loading: false,
                error: action.payload,
            };
        case Types.ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

const loginSuccess = (data) => {
    return {
        type: Types.LOGIN,
        payload: data,
    }
}

const loginError = (data) => {
    return {
        type: Types.ERROR,
        payload: data,
    }
}

const logoutSuccess = (data) => {
    return {
        type: Types.LOGOUT,
        payload: data,
    }
}

export const Creators = {
    loginFirebase: function (email, senha) {
        return (dispatch) => {
            handleLoginFirebase(email, senha)
                .then((res) => {
                    dispatch(loginSuccess(res));
                })
                .catch((error) => {
                    dispatch(loginError(error));
                });
        };
    },
    logoutFirebase: function () {
        return (dispatch) => {
            handleLogout()
                .then((res) => {
                    dispatch(logoutSuccess(res))
                })
        }
    }
}
